import { Alert, Input, Modal, Space } from "antd"
import { useState } from 'react'
import { importBudget, ImportError, ImportResult } from "./importModel"
import { createDefaultWorksheet, Worksheet } from "./budgetCalculatorModel"
import { faFileImport } from "@fortawesome/pro-solid-svg-icons"
import IconAndTextButton from "../IconAndTextButton"

const isError = (result: ImportResult): result is ImportError => {
  return (result as ImportError).error !== undefined
}

type Props = {
  createWorksheet: (worksheet: Worksheet) => void
}

const Import = ({ createWorksheet: selectWorksheet }: Props) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [input, setInput] = useState<string>('')
  const [error, setError] = useState<string>('')

  const handleImport = () => {
    const result = importBudget(input)
    if (isError(result)) {
      setError(result.error)
    }
    else {
      selectWorksheet({
        ...createDefaultWorksheet(),
        title: 'Imported Worksheet',
        data: result.state,
        metadata: {
          createdVia: 'import'
        }
      })
      setModalOpen(false)
    }
  }

  const openModal = () => {
    setModalOpen(true)
    setInput('')
    setError('')
  }

  return <>
    <IconAndTextButton onClick={openModal} icon={faFileImport} text="Import"/>
    <Modal open={modalOpen} title="Import Budget" onCancel={() => setModalOpen(false)} okText="Import" onOk={handleImport}>
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        Paste the data exported from the Budget Summary Calculator
        <Input.TextArea value={input} onChange={e => setInput(e.target.value)} />
        {error && <Alert showIcon type="error" message={error} />}
      </Space>
    </Modal>
  </>
}
export default Import
